import { useCallback, useEffect, useState } from 'react';

import Permissions from '@/common/permissions';
import { useHasAccess, useSnackbar } from '@/modules/core';

import { useGetBankAccountNumberQuery } from '../useGetBankAccountNumber.query';
const REQUIRED_PERMISSIONS = [{ permission: Permissions.VIEW_ER_BANK_ACCOUNT_NUMBER }];

export const useBankAccount = (accountId?: string) => {
  const hasViewAccess = useHasAccess(REQUIRED_PERMISSIONS);
  const [isSetLoading, setIsSetLoading] = useState(false);
  const { handleAddPermanentSnackbar, handleReset } = useSnackbar();
  const [bankAccount, setBankAccount] = useState('');
  const { getAccountNumber, isLoading } = useGetBankAccountNumberQuery();

  const fetchBankAccount = useCallback(async () => {
    if (hasViewAccess && accountId) {
      try {
        const bankAccount = await getAccountNumber(accountId);
        setBankAccount(`${bankAccount?.data}`);
      } finally {
        setIsSetLoading(false);
      }
    } else {
      setIsSetLoading(false);
    }
  }, [hasViewAccess, accountId, getAccountNumber]);

  const handleCopyToClipboardAccountNumber = useCallback(() => {
    handleAddPermanentSnackbar({
      text: 'Account number is copied!',
      closeIcon: true,
      zIndex: 2002,
    });
    setTimeout(() => {
      handleReset();
    }, 2500);
  }, [handleAddPermanentSnackbar, handleReset]);

  useEffect(() => {
    setIsSetLoading(true);
    fetchBankAccount();
  }, [fetchBankAccount]);
  return {
    bankAccount,
    isLoading,
    isSetLoading,
    hasViewAccess,
    handleCopyToClipboardAccountNumber,
  };
};
